module.exports = __webpack_public_path__ + "static/Opgames-7ee098dcc804eeec1d61c9acfc38ef38.svg";